import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {IconData} from "PageBuilder/utils/Dialogs/IconDialog";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {IconDialog} from "PageBuilder/Dialogs/IconDialog";
import {FigureData} from "../../../../PageBuilderPr/Controls/FigureControl.Options";
import {FigureDialog} from "PageBuilder/Dialogs/FigureDialog";

export class FigureProperty extends PropertyBase{
    public label:string="Label";


    public SubRenderer(): React.ReactNode {
        let option:FigureData= this.GetOptionValue();
        return (
            <div style={{cursor:'pointer',width:'100%',textAlign:'center',userSelect:'none'}}>
                <label style={{display:'block',margin:0,textAlign:'left'}}>Icon</label>
                <div style={{border:'1px solid #dfdfdf',display:'inline-block',width:200,height:200}} onClick={e=>this.SelectIcon()}>
                    <img style={{width:'100%',height:'100%'}} src={'data:image/svg+xml;base64,'+this.Options.Data}/>
                </div>
            </div>
        )
    }

    private async SelectIcon() {
        let result=await Dialog.Show(<FigureDialog/>);
        if(result==null)
            return;
        this.SetOptionValue(result);
        this.ForceUpdate();
    }

}